(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-product-recommendations"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .then(() => {
        new Swiper('.product-recommendations__swiper', {
          slidesPerView: 1,
          spaceBetween: 10,

          breakpoints: {
            768: {
              slidesPerView: 3,
              spaceBetween: 16,
            },

            992: {
              slidesPerView: 4,
            },
          },

          watchOverflow: true,

          navigation: {
            nextEl: '.button-next',
            prevEl: '.button-prev',
          },
        });
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-usp-bar"]) return;
  try {
    
  $(() => {
    if (document.querySelector('.header__usp-bar__slider')) {
      initUspBarSlider();
    }
  });

  document.addEventListener('shopify:section:load', () => {
    initUspBarSlider();
  });

  function initUspBarSlider() {
    const sliderElement = document.querySelector('.header__usp-bar__slider');
    const autoplay = sliderElement.getAttribute('data-autoplay');
    const speed = sliderElement.getAttribute('data-speed');

    const options = {
      loop: true,
    };

    if (autoplay) {
      options['autoplay'] = {
        delay: speed * 1000,
      };
    }

    const slider = new Swiper('.header__usp-bar__slider', options);
  }

  } catch(e) { console.error(e); }
})();
})();
